// extracted by mini-css-extract-plugin
export default {"signatureField":"DR1ZAf","header":"uIApQX","inputContainer":"axnih7"};